import {useSafeChatState} from '@github-ui/copilot-chat/utils/CopilotChatContext'
import type {RepositoryVisibility} from '@github-ui/item-picker/RepositoryPicker'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'

export interface ShowCopilotFunctionalityInIssuesOptions {
  additionalConditions?: boolean[]
  repositoryVisibility: RepositoryVisibility
  userCanPushToRepo: boolean
}

export function useShouldShowCopilotFunctionalityInIssues({
  additionalConditions = [],
  repositoryVisibility,
  userCanPushToRepo,
}: ShowCopilotFunctionalityInIssuesOptions): boolean {
  const chatState = useSafeChatState()
  const appPayload = useAppPayload<{current_user_settings?: {copilot_show_functionality?: boolean}}>()

  if (chatState?.mode === 'immersive') return false
  if (!appPayload?.current_user_settings?.copilot_show_functionality) return false
  if (repositoryVisibility === 'PUBLIC' && !userCanPushToRepo) return false

  return additionalConditions.every(condition => condition)
}
